// extracted by mini-css-extract-plugin
export default {"fileUpload":"FileUpload_fileUpload__UpmOl","fileUploadLabelFocused":"FileUpload_fileUploadLabelFocused__ScNUI"};